export default __webpack_public_path__ + "static/media/earaser2.40dc1195.gif";